import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取商品分组列表 */
export function getGoodsGroupedList(data) {
  return request("".concat(BASE_URL) + "/product/group/list", METHOD.GET, data);
}

/* 删除商品分组 #10040 */
export function deleteGoodsGroupedByid(groupId) {
  return request("".concat(BASE_URL) + "/product/group/" + groupId, METHOD.DELETE);
}
/* 保存商品分组（#10039） */
export function saveGoodsGrouped(data) {
  return request("".concat(BASE_URL) + "/product/group", METHOD.POST, data);
}

/* 获取商品分组详情（#10042） */
export function getGoodsGroupedDetail(groupId) {
  return request("".concat(BASE_URL) + "/product/group/" + groupId, METHOD.GET);
}

/* 获取仕入先列表接口（#10055） */
export function getsrxList() {
  return request("".concat(BASE_URL) + "/product/supplierlist", METHOD.GET);
}
export default {
  getGoodsGroupedList: getGoodsGroupedList,
  deleteGoodsGroupedByid: deleteGoodsGroupedByid,
  saveGoodsGrouped: saveGoodsGrouped,
  getGoodsGroupedDetail: getGoodsGroupedDetail,
  getsrxList: getsrxList
};